/**
 * * 작품 관리 - 리소스 - live 일러스트 api
 */
import { ifyouApi, kevinAuthAPI, STORY } from 'apis/config';

export const liveIllustApi = {
  read: (projectId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-illust-list`, {
        lang: lang,
      })
      .then((res) => res.data),
  detailList: (projectId, liveIllustId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-illust-detail-list`, {
        live_illust_id: liveIllustId,
      })
      .then((res) => res.data),
  detail: (projectId, liveIllustId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-illust-detail`, {
        illust_id: liveIllustId,
        illust_type: 'live2d',
      })
      .then((res) => res.data),
  register: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/live-illust-register`, {
        live_illust_name: props.title,
      })
      .then((res) => res.data),
  zipUpload: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/live-illust-upload`, props.formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  update: ({ projectId, illustId, detailData, langList }) =>
    ifyouApi.post(`${STORY}/${projectId}/live-illust-update`, {
      live_illust_id: illustId,
      thumbnail_id: detailData.thumbnail_id,
      live_illust_name: detailData.live_illust_name,
      offset_x: detailData.offset_x,
      offset_y: detailData.offset_y,
      game_scale: detailData.game_scale,
      is_public: detailData.is_public,
      appear_episode: detailData.appear_episode,
      speaker: detailData.speaker,
      langList: langList,
    }),
  delete: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/live-illust-delete`, {
        live_illust_id: String(props.liveIllustId),
      })
      .then((res) => res.data),
  // NEW API
  liveIllustList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/live/${projectId}/live_illust`)
      .then((res) => res.data),
  liveIllustCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_illust`, data)
      .then((res) => res.data),
  liveIllustZip: (projectId, id, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_illust/${id}`, data)
      .then((res) => res.data),
  liveIllustDelete: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/live/${projectId}/live_illust/${id}`)
      .then((res) => res.data),
  liveIllustUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/resource-manager/live/${projectId}/live_illust/${id}`, data)
      .then((res) => res.data),
  liveIllustThumnailUpdate: (projectId, id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .post(`/resource-manager/live-thumbnail/${projectId}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data);
  },
};
